import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCurrentUserQuery } from '../redux/Apis/Auth';
import { logout, setAuthData } from '../redux/Slices/Auth';
import { normalizeSession, tokenClaims } from '../utils/authSession';
import { isReadOnlyPreview } from '../config';

export default function SessionMonitor() {
  const auth = useSelector((state) => state.authSlice);
  const dispatch = useDispatch();
  const valid = normalizeSession(auth).isLoggedIn;
  const { currentData } = useCurrentUserQuery(auth.userId, {
    skip: !valid || isReadOnlyPreview,
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
    refetchOnReconnect: true,
  });
  useEffect(() => {
    if (!auth.token) return;
    let timer;
    const expire = () => {
      window.clearTimeout(timer);
      if (!normalizeSession(auth).isLoggedIn) { dispatch(logout()); return; }
      const remaining = (tokenClaims(auth.token)?.exp || 0) * 1000 - Date.now();
      timer = window.setTimeout(expire, Math.min(remaining + 25, 2147483647));
    };
    expire();
    window.addEventListener('focus', expire);
    return () => { window.clearTimeout(timer); window.removeEventListener('focus', expire); };
  }, [auth, dispatch]);
  useEffect(() => {
    const user = currentData?.data?.user;
    if (valid && currentData?.success && user && String(user._id || user.id) === String(auth.userId) && auth.token) dispatch(setAuthData({ token: auth.token, user }));
  }, [currentData, auth.token, auth.userId, valid, dispatch]);
  return null;
}
